import { render, staticRenderFns } from "./perfilPai.vue?vue&type=template&id=2b23dd19"
import script from "./perfilPai.vue?vue&type=script&lang=js"
export * from "./perfilPai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports